import quotationRequestService from "../../../../services/procurementService/quotationRequestService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_QUOTATIONREQUESTS } from "../../../../utils/constants";
import { QuotationRequestInterface } from "../../../../models/ProcurementModule/QuotationRequest";
import ToastMessage from "../../../../common/ToastMessage";

interface AddVendorContext {
  previousQuotationRequest: QuotationRequestInterface[];
}

const useAddQuotationRequest = (
  purchaseOrderId: string | undefined,
  page: number,
  pageSize: number,
  fileNames: {
    fileUrl: string;
    fileName: string;
  }[]
) => {
  const queryClient = useQueryClient();

  return useMutation<
    QuotationRequestInterface,
    Error,
    QuotationRequestInterface,
    AddVendorContext
  >({
    mutationFn: (item) => quotationRequestService.Create(item, fileNames),

    onMutate: () => {
      const previousQuotationRequest =
        queryClient.getQueryData<QuotationRequestInterface[]>([
          CACHE_KEY_QUOTATIONREQUESTS,
          purchaseOrderId,
          page,
          pageSize,
        ]) || [];

      return { previousQuotationRequest };
    },

    onSuccess: (savedData) => {
      ToastMessage.Success();
      queryClient.setQueryData<QuotationRequestInterface[]>(
        [CACHE_KEY_QUOTATIONREQUESTS, purchaseOrderId, page, pageSize],
        (data) => (data ? [savedData, ...data] : [savedData])
      );
    },

    onError: (error, newData, context) => {
      if (!context) return;
      ToastMessage.Failed();

      queryClient.setQueryData<QuotationRequestInterface[]>(
        [CACHE_KEY_QUOTATIONREQUESTS, purchaseOrderId, page, pageSize],
        context.previousQuotationRequest
      );
    },
  });
};

export default useAddQuotationRequest;
